





import React, { useState } from 'react';
import ApiService from '../../components/Services/ApiServices';
import { useNavigate } from 'react-router';
import { initialAuthState } from '../../components/Services/ApiServices';
import { motion } from 'framer-motion';
import toast, { Toaster } from "react-hot-toast";
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import "./AddHiring.css";

const AddHiring = () => {
  const navigate = useNavigate();

  const [qualifications, setQualifications] = useState([
    { name: '', marks: '', year: '' },
  ]);

  const [formData, setFormData] = useState({
    candidateName: '',
    phoneNumber: '',
    email: '',
    address: '',
    resume: null,
    dateOfUpload: new Date().toISOString().split('T')[0],
    status: 'INTERVIEWED',
    companyCode: initialAuthState.companyCode,
    unitCode: initialAuthState.unitCode,
  });

  const [fileUploadedMessage, setFileUploadedMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleQualificationChange = (index, field, value) => {
    const updatedQualifications = [...qualifications];
    updatedQualifications[index][field] = value;
    setQualifications(updatedQualifications);
  };

  const handleAddQualification = () => {
    setQualifications([...qualifications, { name: '', marks: '', year: '' }]);
  };

  const handleRemoveQualification = (index) => {
    const updatedQualifications = qualifications.filter((_, i) => i !== index);
    setQualifications(updatedQualifications);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Check file size (5MB limit)
      if (file.size > 5 * 1024 * 1024) {
        toast.error('File size too large. Please upload a file smaller than 5MB.');
        return;
      }

      // Check file type
      const allowedTypes = ['.pdf', '.doc', '.docx'];
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
      if (!allowedTypes.includes(fileExtension)) {
        toast.error('Invalid file type. Please upload PDF, DOC, or DOCX files only.');
        return;
      }

      const fileName = file.name;
      setFileUploadedMessage(fileName);
      setFormData((prev) => ({
        ...prev,
        resumePath: fileName,
        resume: file,
      }));
      toast.success('Resume uploaded successfully!');
    }
  };

  const validateForm = () => {
    if (!formData.candidateName.trim()) {
      toast.error('Please enter your full name');
      return false;
    }
    if (!formData.phoneNumber.trim()) {
      toast.error('Please enter your phone number');
      return false;
    }
    if (!formData.email.trim()) {
      toast.error('Please enter your email address');
      return false;
    }
    if (!formData.address.trim()) {
      toast.error('Please enter your address');
      return false;
    }
    if (!formData.resume) {
      toast.error('Please upload your resume');
      return false;
    }

    // Validate qualifications
    for (let i = 0; i < qualifications.length; i++) {
      const qual = qualifications[i];
      if (!qual.name.trim() || !qual.marks.trim() || !qual.year.trim()) {
        toast.error('Please fill all qualification fields or remove empty ones');
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    // Validate form before submission
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    const submitToast = toast.loading('Submitting your application...');

    try {
      const payload = new FormData();

      // Append all form data
      payload.append('candidateName', formData.candidateName);
      payload.append('phoneNumber', formData.phoneNumber);
      payload.append('email', formData.email);
      payload.append('address', formData.address);
      payload.append('dateOfUpload', formData.dateOfUpload);
      payload.append('status', formData.status);
      payload.append('companyCode', formData.companyCode);
      payload.append('unitCode', formData.unitCode);

      // Append qualifications
      qualifications.forEach((q, index) => {
        payload.append(`qualifications[${index}][qualificationName]`, q.name);
        payload.append(`qualifications[${index}][marks]`, q.marks);
        payload.append(`qualifications[${index}][yearOfPass]`, q.year);
      });

      // Append resume file
      if (formData.resume) {
        payload.append('file', formData.resume);
      }

      // Make POST request to careers endpoint
      const response = await ApiService.post(
        "/hiring/saveHiringDetailsWithResume",
        payload,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );

      if (response.status === 200 || response.status) {
        toast.dismiss(submitToast);
        toast.success('🎉 Application submitted successfully!', {
          duration: 5000,
        });

        // Show success message and reset form
        setTimeout(() => {
          resetForm();
          toast.success('📧 We have received your application! Our HR team will contact you soon.', {
            duration: 6000,
          });
        }, 1000);

      } else {
        toast.dismiss(submitToast);
        toast.error('❌ Failed to submit application. Please try again.');
      }
    } catch (error) {
      console.error('Error saving career details:', error);
      toast.dismiss(submitToast);
      toast.error('❌ Failed to submit application. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData({
      candidateName: '',
      phoneNumber: '',
      email: '',
      address: '',
      resume: null,
      dateOfUpload: new Date().toISOString().split('T')[0],
      status: 'INTERVIEWED',
      companyCode: initialAuthState.companyCode,
      unitCode: initialAuthState.unitCode,
    });
    setQualifications([{ name: '', marks: '', year: '' }]);
    setFileUploadedMessage('');
  };

  // Handle phone call
  const handlePhoneClick = () => {
    window.open('tel:+917995512053');
  };

  // Handle email
  const handleEmailClick = () => {
    window.open('mailto:hr@sharontelematics.com');
  };

  return (

    <div className="career-page-container">
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
            fontSize: '14px'
          },
          success: {
            duration: 5000,
            iconTheme: {
              primary: '#60A442',
              secondary: '#fff'
            }
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#ff4d4f',
              secondary: '#fff'
            }
          },
          loading: {
            duration: Infinity
          }
        }}
      />

      {/* Hero Section */}

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="career-page-hero"
      >

        <h1 className="career-page-title">
          Join Our Team
        </h1>

        <p className="career-page-lead">
          We're looking for talented individuals who are passionate about innovation and technology.
          Start your journey with us today.
        </p>

        <div className="career-page-stats">

          <div className="career-page-stat">
            <div className="career-page-stat-number">50+</div>
            <div className="career-page-stat-text">Team Members</div>
          </div>

          <div className="career-page-stat">
            <div className="career-page-stat-number">10+</div>
            <div className="career-page-stat-text">Countries</div>
          </div>

          <div className="career-page-stat">
            <div className="career-page-stat-number">5+</div>
            <div className="career-page-stat-text">Years Experience</div>
          </div>

        </div>

      </motion.div>

      <div className="career-page-grid">

        {/* FORM */}

        <div className="career-page-form-wrapper">

          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >

            <div className="career-page-card">

              <div className="career-page-card-header">
                <h3>Application Form</h3>
              </div>

              <div className="career-page-card-body">

                <div className="career-page-form-grid">

                  <input
                    type="text"
                    name="candidateName"
                    value={formData.candidateName}
                    onChange={handleInputChange}
                    placeholder="Enter your full name"
                    required
                    disabled={isSubmitting}
                  />

                  <input
                    type="text"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    placeholder="Enter phone number"
                    required
                    disabled={isSubmitting}
                  />

                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter email address"
                    required
                    disabled={isSubmitting}
                  />

                  <textarea
                    rows="3"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    placeholder="Enter your complete address"
                    required
                    disabled={isSubmitting}
                  />

                </div>

                {/* Qualifications */}

                <div className="career-page-qualification-section">

                  <div className="career-page-qualification-header">

                    <h5>Educational Qualifications</h5>

                    <button
                      onClick={handleAddQualification}
                      className="career-page-add-btn"
                      disabled={isSubmitting}
                    >
                      <i className="bi bi-plus-circle"></i>
                      Add Qualification
                    </button>

                  </div>

                  {qualifications.map((qualification, index) => (
                    <div key={index} className="career-page-qualification-row">

                      <input
                        type="text"
                        placeholder="Degree/Qualification"
                        value={qualification.name}
                        onChange={(e) => handleQualificationChange(index, 'name', e.target.value)}
                        disabled={isSubmitting}
                        className='career-page-qualification-input'
                      />

                      <input
                        type="text"
                        placeholder="Marks/CGPA"
                        value={qualification.marks}
                        onChange={(e) => handleQualificationChange(index, 'marks', e.target.value)}
                        disabled={isSubmitting}
                        className='career-page-qualification-input'
                      />

                      <input
                        type="text"
                        placeholder="Year"
                        value={qualification.year}
                        onChange={(e) => handleQualificationChange(index, 'year', e.target.value)}
                        disabled={isSubmitting}
                        className='career-page-qualification-input'
                      />

                      <button
                        className="career-page-delete-btn"
                        onClick={() => handleRemoveQualification(index)}
                        disabled={isSubmitting || qualifications.length === 1}
                      >
                        <i className="bi bi-trash"></i>
                      </button>

                    </div>
                  ))}

                </div>

                {/* Resume Upload */}

                <div className="career-page-upload">

                  <input
                    type="file"
                    accept=".pdf,.doc,.docx"
                    onChange={handleFileUpload}
                    disabled={isSubmitting}
                    className='career-page-qualification-upload-input'
                  />

                  {fileUploadedMessage && (
                    <div className="career-page-upload-success">
                      <i className="bi bi-check-circle-fill"></i>
                      File uploaded: {fileUploadedMessage}
                    </div>
                  )}

                </div>

                <div className="career-page-submit-area">

                  <button
                    onClick={handleSubmit}
                    className="career-page-submit-btn"
                    disabled={isSubmitting}
                  >

                    {isSubmitting ? (
                      <>
                        <span className="career-page-spinner"></span>
                        Submitting...
                      </>
                    ) : (
                      'Submit Application'
                    )}

                  </button>

                </div>

              </div>
            </div>

          </motion.div>
        </div>

        {/* BENEFITS */}

        <div className="career-page-benefits-wrapper">

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >

            <div className="career-page-benefits-card">

              <h4>Why Join Us?</h4>

              <div className="career-page-benefits-list">

                {[
                  { icon: '💼', title: 'Competitive Salary', desc: 'Industry-standard compensation packages' },
                  { icon: '🏠', title: 'Flexible Work', desc: 'Remote and hybrid work options' },
                  { icon: '📚', title: 'Learning & Growth', desc: 'Continuous skill development programs' },
                  { icon: '⚕️', title: 'Health Benefits', desc: 'Comprehensive medical insurance' },
                  { icon: '🎯', title: 'Career Progression', desc: 'Clear growth paths and promotions' },
                  { icon: '🤝', title: 'Great Culture', desc: 'Collaborative and inclusive environment' }
                ].map((benefit, index) => (
                  <div key={index} className="career-page-benefit-item">
                    <span className="career-page-benefit-icon">{benefit.icon}</span>
                    <div>
                      <h6>{benefit.title}</h6>
                      <p>{benefit.desc}</p>
                    </div>
                  </div>
                ))}

              </div>

            </div>

            <div className="career-page-contact-card">

              <h5>Have Questions?</h5>

              <div className='career-page-contact-btn-container'>
                <button
                  className="career-page-contact-btn"
                  onClick={handleEmailClick}
                >
                  <i className="bi bi-envelope"></i>
                  hr@sharontelematics.com
                </button>

                <button
                  className="career-page-contact-btn"
                  onClick={handlePhoneClick}
                >
                  <i className="bi bi-telephone"></i>
                  +91 7995512053
                </button>
              </div>

            </div>

          </motion.div>

        </div>

      </div>

      {/* Hiring Process */}

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.6 }}
        className="career-page-process"
      >

        <h3>Our Hiring Process</h3>

        <div className="career-page-process-grid">

          {[
            { step: '1', title: 'Application Review', desc: 'We carefully review each application' },
            { step: '2', title: 'Initial Screening', desc: 'Phone interview with HR team' },
            { step: '3', title: 'Technical Assessment', desc: 'Skills and knowledge evaluation' },
            { step: '4', title: 'Final Interview', desc: 'Meeting with team leads' },
            { step: '5', title: 'Offer', desc: 'Welcome to the team!' }
          ].map((process, index) => (
            <div key={index} className="career-page-process-step">

              <div className="career-page-process-circle">
                {process.step}
              </div>

              <h6>{process.title}</h6>
              <p>{process.desc}</p>

            </div>
          ))}

        </div>

      </motion.div>

    </div>

  );
};

export default AddHiring;